(() => {
  const loader = document.currentScript || document.querySelector("script[data-sticky-buy-script]");
  const scriptSrc = loader?.dataset.stickyBuyScript;
  const styleHref = loader?.dataset.stickyBuyStyle;
  const bar = document.querySelector("sticky-buy-bar");

  if (!scriptSrc || !bar || customElements.get("sticky-buy-bar")) return;

  let loadPromise;

  const loadStyle = () => {
    if (!styleHref || document.querySelector(`link[href="${styleHref}"]`)) return Promise.resolve();

    return new Promise((resolve, reject) => {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = styleHref;
      link.onload = resolve;
      link.onerror = reject;
      document.head.append(link);
    });
  };

  const load = () => {
    if (loadPromise) return loadPromise;

    loadPromise = loadStyle().then(() => new Promise((resolve, reject) => {
      const existing = [...document.scripts].find((script) => script.src === scriptSrc);
      if (existing) {
        resolve();
        return;
      }

      const script = document.createElement("script");
      script.src = scriptSrc;
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.append(script);
    }));

    return loadPromise;
  };

  const onFirstScroll = () => {
    load();
    window.removeEventListener("scroll", onFirstScroll);
    window.removeEventListener("touchstart", onFirstScroll);
  };

  window.addEventListener("scroll", onFirstScroll, { passive: true, once: true });
  window.addEventListener("touchstart", onFirstScroll, { passive: true, once: true });
})();
